import React, { createContext, useContext, useState, ReactNode } from "react";

interface TenantLogoContextType {
  previewLogoUrl: string | null;
  setPreviewLogoUrl: (url: string | null) => void;
}

const TenantLogoContext = createContext<TenantLogoContextType | undefined>(undefined);

export function TenantLogoProvider({ children }: { children: ReactNode }) {
  const [previewLogoUrl, setPreviewLogoUrl] = useState<string | null>(null);

  return (
    <TenantLogoContext.Provider value={{ previewLogoUrl, setPreviewLogoUrl }}>
      {children}
    </TenantLogoContext.Provider>
  );
}

export function useTenantLogoPreview() {
  const context = useContext(TenantLogoContext);
  if (!context) {
    throw new Error("useTenantLogoPreview must be used within a TenantLogoProvider");
  }
  return context;
}
